module.exports = __webpack_public_path__ + "static/Frogsong0-bccfb85829c6e27c7a95cf40760a8420.png";